export const FETCH_ORDER_DELIVERY_PENDING = "FETCH_ORDER_DELIVERY_PENDING";
export const FETCH_ORDER_DELIVERY_REJECTED = "FETCH_ORDER_DELIVERY_REJECTED";
export const FETCH_ORDER_DELIVERY_FULFILLED = "FETCH_ORDER_DELIVERY_FULFILLED";



// WEBPACK FOOTER //
// ./src/constants/orderDelivery.js